import alerts from './tasks/alerts';
import buttons from './tasks/buttons';

export default {
    alerts,
    buttons,

    head: {
        taskView: 'Просмотр задачи',
    },

    alert: {
        secondary: 'Задача в обработке',
        danger: 'Ошибка',
    },

    fields: {
        orderId: 'Номер заказа',
        taskType: 'Тип задачи',
        taskDate: 'Дата создания',
        dateComplete: 'Дата исполнения',
        taskStatus: 'Статус',
        pfm: 'Код магазина ПФМ',
        deliveryServiceId: 'Тип доставки',
        taskImportance: 'Приоритет',
        taskId: 'Номер задачи',
        updatedFrom: 'Система',
    },

    packagesPerOrder: {
        title: 'Пакеты в заказе',
        packageType: 'Тип пакета',
        numberOfPcs: 'Количество шт.',
        setPackagesCount: 'Пожалуйста, укажите количество пакетов',
        packageCountNotification: 'Необходимо добавить хотя бы 1 пакет в заказ, но не больше {quantity} шт.',
        packInSpecifiedQuantity: 'Необходимо собрать заказ в указанное количество пакетов!',
        needMorePackages: 'В заказе уже есть 1 пакет, добавить ещё?',
    },

    filter: {
        orderId: 'Номер заказа',
        taskDateFrom: 'Дата создания: от',
        taskDateTo: 'Дата создания: до',
        pfm: 'Код магазина ПФМ',
        taskTypes: 'Тип задачи',
        statuses: 'Статус',
        selectedTaskTypes: 'Выбрано типов',
        selectedStatuses: 'Выбрано статусов',

        types: {
            action: 'Актуальные',
            all: 'Все',
        },

        buttonClear: 'Очистить',
    },

    list: {
        deliveryService: 'Самовывоз',
        textFormsPre: 'Найдена | Найдено | Найдено',
        textFormsPast: 'задача | задачи | задач',
    },

    view: 'Задача на {title} № {orderId}',

    mixins: {
        types: {
            formatting: 'формирование заказа',
            confirming: 'согласование заказа',
            disbanding: 'расформирование заказа',
            paying: 'отметка об оплате заказа',
            delivery: 'выдача в доставку заказа',
            printTransferDoc: 'печать передаточных документов',
            formationDelivery: 'формирование в доставку заказа',
            confirmingDelivery: 'согласование заказа с доставкой',
            editAfterFormatting: 'редактирование после формирования заказа',
            returnFromShipping: 'возврат от курьерских служб',
        },

        typeTitle: 'действия с заказом',
    },
};